import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import resume from "../img/Pratyush_Kumar_Rai_Resume.pdf";
import "./styles/CommandPalette.scss";

const COMMANDS = [
  { id: "home", title: "Home", category: "Navigation", icon: "fa-home", action: (history) => history.push("/") },
  { id: "portfolio", title: "Featured Projects & Experience", category: "Navigation", icon: "fa-th-large", action: (history) => history.push("/portfolio") },
  { id: "about", title: "About, Skills & Education", category: "Navigation", icon: "fa-user", action: (history) => history.push("/about") },
  { id: "contact", title: "Contact Details", category: "Navigation", icon: "fa-envelope", action: (history) => history.push("/contact") },
  { id: "resume", title: "Download Resume (PDF)", category: "Actions", icon: "fa-download", action: () => {
    const a = document.createElement("a");
    a.href = resume;
    a.download = "Pratyush_Kumar_Rai_Resume.pdf";
    a.click();
  }},
  { id: "copy-email", title: "Copy Email (pratyushkumarrai3@gmail.com)", category: "Actions", icon: "fa-clipboard", action: (_, showToast) => {
    navigator.clipboard.writeText("pratyushkumarrai3@gmail.com");
    if (showToast) showToast("Copied email to clipboard!");
  }},
  { id: "dishdiary", title: "DishDiary — Live Demo (Web)", category: "Projects", icon: "fa-external-link", action: () => window.open("https://dishdiaryy.vercel.app", "_blank") },
  { id: "serendipity", title: "Serendipity — Live Platform", category: "Projects", icon: "fa-external-link", action: () => window.open("https://serendi.pt", "_blank") },
  { id: "publication", title: "FTNCT 2024 Research Publication (ScienceDirect)", category: "Projects", icon: "fa-book", action: () => window.open("https://www.sciencedirect.com/science/article/pii/S1877050925010889", "_blank") },
  { id: "github", title: "GitHub Profile (@PratyushKumarRai)", category: "Socials", icon: "fa-github", action: () => window.open("https://github.com/PratyushKumarRai", "_blank") },
  { id: "linkedin", title: "LinkedIn Profile", category: "Socials", icon: "fa-linkedin", action: () => window.open("https://www.linkedin.com/in/pratyushkumarrai/", "_blank") },
];

function CommandPalette({ isOpen, onClose, onToast }) {
  const [query, setQuery] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(0);
  const inputRef = useRef(null);
  const history = useHistory();

  const filteredCommands = COMMANDS.filter((cmd) =>
    cmd.title.toLowerCase().includes(query.toLowerCase()) ||
    cmd.category.toLowerCase().includes(query.toLowerCase())
  );

  useEffect(() => {
    if (isOpen) {
      setQuery("");
      setSelectedIndex(0);
      setTimeout(() => inputRef.current?.focus(), 100);
    }
  }, [isOpen]);

  useEffect(() => {
    setSelectedIndex(0);
  }, [query]);

  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      onClose();
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      setSelectedIndex((prev) => (prev + 1) % Math.max(1, filteredCommands.length));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setSelectedIndex((prev) => (prev - 1 + filteredCommands.length) % Math.max(1, filteredCommands.length));
    } else if (e.key === "Enter" && filteredCommands.length > 0) {
      e.preventDefault();
      executeCommand(filteredCommands[selectedIndex]);
    }
  };

  const executeCommand = (cmd) => {
    if (!cmd) return;
    cmd.action(history, onToast);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="command-palette-backdrop" onClick={onClose} role="dialog" aria-modal="true" aria-label="Command Palette">
      <div className="command-palette-modal" onClick={(e) => e.stopPropagation()} onKeyDown={handleKeyDown}>
        <div className="palette-input-wrap">
          <i className="fa fa-search palette-search-icon" aria-hidden="true"></i>
          <input
            ref={inputRef}
            type="text"
            className="palette-input font-mono"
            placeholder="Type a command or jump to section..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <kbd className="palette-esc-badge" onClick={onClose}>ESC</kbd>
        </div>

        <div className="palette-results">
          {filteredCommands.length === 0 ? (
            <div className="palette-empty font-mono">No matching commands found.</div>
          ) : (
            filteredCommands.map((cmd, idx) => (
              <div
                key={cmd.id}
                className={`palette-item ${idx === selectedIndex ? "active" : ""}`}
                onClick={() => executeCommand(cmd)}
                onMouseEnter={() => setSelectedIndex(idx)}
              >
                <div className="item-left">
                  <i className={`fa ${cmd.icon} item-icon`} aria-hidden="true"></i>
                  <span className="item-title">{cmd.title}</span>
                </div>
                <span className="item-category font-mono">{cmd.category}</span>
              </div>
            ))
          )}
        </div>

        <div className="palette-footer font-mono">
          <span><kbd>↑</kbd> <kbd>↓</kbd> Navigate</span>
          <span><kbd>↵</kbd> Select</span>
          <span><kbd>ESC</kbd> Close</span>
        </div>
      </div>
    </div>
  );
}

export default CommandPalette;
